{
	"ariaCropAspectRatioMenu": "Crop Aspect Ratio Menu",
	"ariaSelectCropAspectRatio": "Select Crop Aspect Ratio",
	"aspect": "Aspect",
	"custom": "Custom",
	"original": "Original"
}
